import React from 'react';
import createSvgIcon from '../../../utils/createSvgIcon';

export default createSvgIcon(
  [<g key="0"><path fill="currentColor" d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2M9.5 16.5v-9l7 4.5z" /></g>,<defs key="1"></defs>,]
, 'CameraVideoVideoFilledx');
